namespace GeniuzPOS.PosShift {
    import fld = PsVatRefundRow.Fields


    @Serenity.Decorators.registerClass()
    export class PsVatRefundGrid extends Serenity.EntityGrid<PsVatRefundRow, any> {
        protected getColumnsKey() { return PsVatRefundColumns.columnsKey; }
        protected getDialogType() { return PsVatRefundDialog; }
        protected getIdProperty() { return PsVatRefundRow.idProperty; }
        protected getInsertPermission() { return PsVatRefundRow.insertPermission; }
        protected getLocalTextPrefix() { return PsVatRefundRow.localTextPrefix; }
        protected getService() { return PsVatRefundService.baseUrl; }

        private _selectedPrint: string;

        protected getColumns() {
            var columns = super.getColumns();

            // var item = this.itemAt(row);
            // if()

            columns.splice(4, 0, {
                id: 'Print Vatrefund',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-Vatrefund" title="PsTaxInvoiceprint">' +
                        '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });



            return columns;
        }


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            // if (e.isDefaultPrevented())
            //     return;

            var item = this.itemAt(row);
            var target = $(e.target);


            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('print-Vatrefund')) {
                   
                    
                    this.view.getRows()
                    const request = {} as VatRefundData
                    request.DocNo = item.DocNo 
                    request.Header = PsVatRefundRow.getLookup().itemById[item.DocNo]           
                    var Details = PsVatRefundDtRow.getLookup().items.filter(x => x.DocNo == item.DocNo)

                    request.Details = Details
                    request.sumfristpage = Details.slice(0, 12).reduce((sum, detail) => sum + detail.Amt, 0);
                    request.sumtopage = item.Total - request.sumfristpage;
                    let con = Q.tryFirst(Lookups.SysCountryRow.getLookup().items, x => x.CounShowCode == item.Country)
                    let country = con != null ? con.CountryName : "";
                    request.buyCountry = country;

                    let count = Details.length
                    let lesspage = Math.ceil((count - 12) % 16)                    
                    if(lesspage > 0){
                        request.AllPage  = Math.floor(Math.ceil((count - 12) / 16)) + 2;
                    }else{ 
                        request.AllPage  = Math.floor(Math.ceil((count - 12) / 16)) + 1;
                    }
                    request.ToPage = request.AllPage-1;
                    
                    console.log(request.sumfristpage)
                    
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    if (fg != null) {
                        let s = Q.tryFirst(Lookups.VwpsShopRow.getLookup().items, x => x.ShopId == item.ShopId)
                        request.BizName = s.ShopNameEn
                        request.BranchName = s.BranchTaxCode
                        request.ShopTaxId = s.ShopTaxId
                        request.Addressno = s.ShopBuildingNoEn + s.ShopBuildingNameEn
                        request.Street = s.ShopStreetNameEn
                        request.District = s.ShopDistrictEn
                        request.Province = s.ShopProvinceEn
                        request.TelNo = s.TelId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                        request.BizName = q.BizNameEn
                        request.BranchName = q.BranchNo                       
                        request.ShopTaxId = q.TaxId
                        request.Addressno = q.BuildingNoEn + q.BuildingNameEn
                        request.Street = q.StreetNameEn
                        request.District = q.DistrictEn
                        request.Province = q.ProvinceEn
                        request.TelNo = q.TelId
                    }

                    // let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)
                    // let sss = p.ShopLogoOnFrontScreen
                    // if (!Q.isEmptyOrNull(sss)) {
                    //     let vp = window.location.href.replace("#", "")
                    //     console.log(vp)
                    //     let ap = vp.replace("/PosShift/PsTaxInvoiceHd", "")
                    //     request.URLpic = ap + "/upload/" + p.ShopLogoOnFrontScreen

                    // } else {
                    //     request.URLpic = "SARAPADTHAIENG.png" //wwwroot\Content\site\images\SARAPADTHAIENG.png

                    // }
                    if(this._selectedPrint == null || this._selectedPrint == "Default"){
                        request.ConfigPrintFg = 0;                        
                    }else{
                        request.ConfigPrintFg = 1;
                        request.ConfigPrint = PsVatRefundPrintingParaRow.getLookup().itemById[this._selectedPrint]
                    }
                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    // if(request.ToPage > 0){
                    // Q.postToService({ service: this.getService() + '/ExportPdf2', request: request, target: '_blank' })
                    // }
                        // GeniuzPOS.Purchase.PoPurInvoiceService.GetNextNumber
                        // }else{
                        //     Q.warning("เอกสารนี้ยังไม่ผ่านการอนุมัติ โปรดทำการอนุมัติเอกสารก่อน")
                        // }

                        ;
                }



            }
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate() - 13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
                
            };

            
            const ConfigPrint: Serenity.QuickFilter<Serenity.Widget<any>, any> = {
                field: "ConfigPrint",
                type: Serenity.LookupEditor,
                title: "Config Print",
                cssClass: "Config-filter",
                options: {
                    lookupKey: "PosShift.PsVatRefundPrintingPara"
                },
                handler: (e: Serenity.LookupEditor) => {
                    this._selectedPrint = e.value;
                    if (Q.isEmptyOrNull(e.value)) {
                        e.value = "Default";
                        this._selectedPrint = "Default"
                        return;
                    }
                }
            }
             filters.push(ConfigPrint)


            return filters;
        }


        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);


            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsVatRefundService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );


            return buttons;
        }

    }
}